function getFileType(filename: string) {
  const paths = filename.toLowerCase().split(".");
  const extension = paths[paths.length - 1];

  if (extension === "pdf") return "application/pdf";
  else if (extension === "jpeg" || extension === "jpg") return "image/jpeg";
  else if (extension === "png") return "image/png";
}

const getPopulatedValues = (responseData: any) => {
  const customer = responseData?.customer || {};
  const address = responseData?.address || {};
  const bank = responseData?.bank || {};
  const documents = Array.isArray(responseData?.documents)
    ? responseData.documents
    : [];
  const assignedSalesRep = responseData?.assignedSalesRep || null;
  const sellerDetails = responseData?.seller_details || null;

  const findDocument = (type: any) =>
    documents.find((doc: any) => doc?.type === type) || null;

  const createDocumentObject = (document: any) => {
    if (!document || !document.fileName) return "";
    return {
      name: document.fileName || "",
      fileType: getFileType(document.fileName || ""),
      url: document.documentId || "",
      originalObj: document,
    };
  };

  const step1 = {
    outletName: customer.outletName || "",
    companyGST: customer.companyGSTNumber || "",
    companyPAN: customer.companyPANNumber || "",
    registeredAddress: address.registeredAddress || "",
    authorizedSignatory: customer.companySignatoryName || "",
    vatNumber: customer.vatNumber || "",
    state: customer.state || "",
    pincode: customer.pincode || "",
    emailID: customer.emailId || "",
    gstStateCode: customer.gstStateCode || "",
    phoneNumber: customer.phoneNumber || "",
    comp_gst_cert: createDocumentObject(findDocument("comp_gst_cert")),
    comp_pan_card: createDocumentObject(findDocument("comp_pan_card")),
    comp_vat_cert: createDocumentObject(findDocument("comp_vat_cert")),
  };

  const step2 = {
    licenseName: address.licenseName || "",
    licenseType: address.licenseType || "",
    customerExciseRegistrationNumber: address.exciseRegistrationNumber || "",
    licensePAN: address.licensePANNumber || "",
    licenseGST: address.licenseGSTNumber || "",
    licenseAddress: address.licenseAddress || "",
    gstStateCode: address.gstStateCode || "",
    lic_rvb_license: createDocumentObject(findDocument("lic_rvb_license")),
    lic_license_pan: createDocumentObject(findDocument("lic_license_pan")),
    lic_gst_cert: createDocumentObject(findDocument("lic_gst_cert")),
  };

  const step3 = {
    bankName: bank.bankName || "",
    bankBranch: bank.bankBranch || "",
    accountType: bank.accountType || "",
    accountNumber: bank.bankAccountNumber || "",
    ifscCode: bank.ifscCode || "",
    beneficiaryName: bank.beneficiaryName || "",
    accountsDepartmentPOCName: bank.accountsDeptPOCName || "",
    accountsDepartmentPOCNumber: bank.accountsDeptPOCNumber || "",
    bank_cancelled_cheque: createDocumentObject(
      findDocument("bank_cancelled_cheque")
    ),
  };

  const customerAgreements = {
    signed:
      documents.find((doc: any) => doc.type === "signed_agreement") || null,
    unsigned:
      documents.find((doc: any) => doc.type === "unsigned_agreement") || null,
  };

  const advancePaymentMandatory = !!customer.advancePaymentMandatory;
  const emailActivation = !!customer.activationEmail;

  return {
    customerAgreements,
    advancePaymentMandatory,
    emailActivation,
    assignedSalesRep,
    sellerDetails,
    step1,
    step2,
    step3,
    agreementContext: customer.agreementContext || null,
  };
};

export default getPopulatedValues;
